import React from 'react';
import clsx from 'clsx';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  hover?: boolean;
  onClick?: () => void;
}

const paddingClasses = {
  none: '',
  sm: 'p-3 md:p-4',
  md: 'p-3 md:p-6',
  lg: 'p-4 md:p-8',
};

const Card: React.FC<CardProps> = ({
  children,
  className,
  padding = 'md',
  hover = false,
  onClick,
}) => {
  return (
    <div
      className={clsx(
        'rounded-2xl border border-line bg-gradient-to-b from-fill-2 to-fill-1 shadow-[inset_0_1px_0_rgba(255,255,255,0.06),0_24px_48px_-28px_rgba(0,0,0,0.8)] transition-all duration-200',
        paddingClasses[padding],
        hover && 'cursor-pointer hover:border-line hover:-translate-y-0.5',
        className,
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default Card;

interface CardHeaderProps {
  children: React.ReactNode;
  className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className }) => (
  <div className={clsx('mb-4 flex items-center justify-between', className)}>
    {children}
  </div>
);

export const CardTitle: React.FC<CardHeaderProps> = ({ children, className }) => (
  <h3 className={clsx('text-lg font-semibold text-fg-primary', className)}>{children}</h3>
);
